try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, jsx } from 'react/jsx-runtime';
import { Icon } from '@design-system/icon';
import classNames from 'classnames';
import { forwardRef } from 'react';

const ErrorMessage = forwardRef(({ className, message, showIcon = true }, ref) => message ? (jsxs("div", Object.assign({ ref: ref, className: classNames('cds-error-message', className), role: "alert" }, { children: [showIcon && (jsx(Icon, { className: classNames('cds-error-icon', className), icon: "tooltip", size: "10" })), message] }))) : null);

export { ErrorMessage };
